import { render, staticRenderFns } from "./EditEnrollment.vue?vue&type=template&id=b9671558&"
import script from "./EditEnrollment.vue?vue&type=script&lang=js&"
export * from "./EditEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports